// extracted by mini-css-extract-plugin
export default {"root":"AppLayout_root-wII","rootChatView":"AppLayout_rootChatView-OGO","mainChatView":"AppLayout_mainChatView-ROc","main":"AppLayout_main-x3u","footer":"AppLayout_footer-z3d"};